const tidioSrc = '//code.tidio.co/kbgdurjvnsbj5xswzilakvymabyyv3dl.js';

export default tidioSrc;



// WEBPACK FOOTER //
// ./src/config/tidioSrc.js